import { checkFakeSubscription, getProviderFormService } from '../../../helper';

/**
 *
 * @param {object} serviceData
 * @param {object|null }modal
 * @description
 *
 * Для Mode === 0 (Manual) показываем всегда
 * Для Mode === 1 (Auto)
 * Если услуга Fake subscription - не показываем
 *
 * @returns {boolean}
 */
export default (serviceData, modal) => {
  const { mode, provider_service_id } = serviceData.form;
  if (mode === 1) {
    const isFakeSubscription = checkFakeSubscription(modal);
    if (isFakeSubscription) {
      return false;
    }
    if (serviceData?.form && serviceData?.providerForm) {
      const { providerForm } = serviceData;
      const service = getProviderFormService(provider_service_id, providerForm);
      if (service) {
        if (service.hasOwnProperty('service_type')) {
          const { service_type } = service;
          if (service_type === 100 || service_type === 101) {
            return false;
          }
        }
      }
    }
    return true;
  }
  return false;
};
